import React from 'react';
import { cn } from '@utils/cn';

interface CardProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}

export const Card: React.FC<CardProps> = ({
  title,
  description,
  icon,
  actions,
  children,
  className,
  noPadding = false,
}) => {
  return (
    <div className={cn("bg-white rounded-lg border border-gray-200 shadow-sm", className)}>
      {(title || actions) && (
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-start">
          <div className="flex items-start space-x-3 flex-1">
            {icon && (
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-ncaa-primary bg-opacity-10 rounded-lg flex items-center justify-center text-ncaa-primary">
                  {icon}
                </div>
              </div>
            )}
            <div className="flex-1 min-w-0">
              {title && <h3 className="text-lg font-semibold text-gray-900">{title}</h3>}
              {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
            </div>
          </div>
          {actions && <div className="flex-shrink-0 ml-4">{actions}</div>}
        </div>
      )}
      <div className={cn(noPadding ? "" : "p-6")}>
        {children}
      </div>
    </div>
  );
};
